// Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.

export function addressRequired(): (data: string) => void {
  return v => !!v || 'Address is required';
}
export function addressValid(): (data: string) => void {
  return v => /http.?:\/\/.+/.test(v) || 'Address must be valid';
}
export function pathNameValid(): (data: string) => void {
  return v => !!v || 'This field is required';
}
export function pathNameMaxLength(): (data: string) => void {
  return v => (v && v.length < 20) || 'Max length 20 characters';
}
